import { Navigate, useLocation } from "react-router-dom";
import { canAccess } from "@/config/roleViews";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-sm label-caps">
        Loading ERP…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  // Role-view guard: a page outside the user's view bounces to the dashboard
  // (the server still enforces permissions independently).
  if (loc.pathname !== "/" && !canAccess(user, loc.pathname)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
